import React, {
  Component
} from 'react';
const $=window.$;


export default class Quotes extends Component {
 componentDidMount() {
   setTimeout(()=>{
    //Fancy Box
    $(".fancybox").fancybox({
     autoPlay : true, //  slideshow will start after opening the first gallery item
     playSpeed : 3000 // 3sec pause between changing next item
    });
    $('.fancybox-media')
    .attr('rel', 'media-gallery')
    .fancybox({
     openEffect : 'none',
     closeEffect : 'none',
     prevEffect : 'none',
     nextEffect : 'none',
     arrows : false,
     autoPlay : true,
     playSpeed : 3000,
     helpers : {
     media : {},
     buttons : {}
    }
    });

   },100);
 }

  render() {
    return (
     <section className="quote-pad parallax">
       <div className="row">
         <div className="quote-txt">
           <div className="quote-lft"><img src={process.env.PUBLIC_URL +'/images/quote.png'} alt=""/></div>
           <div className="quote-rgt">
             <h2>REDESIGN <span>/</span> INNOVATE <span>/</span> ENGAGE</h2>
             <h3>We believe … </h3>
             <p>effective online learning is more than just a library of <span>recorded videos and some</span> <br/>
               <span>e-books.</span> We constantly redesign and deliver effective courseware, <br/>
               and innovate new ways of engaging with the learners. </p>
           </div>
         </div>
       </div>
     </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/Quotes.js